/**
 * lib/videoTime.js — 🆕 2026-08-31 · Zeitangaben in beiden Formaten.
 *
 * Drei Tabellen zeigten dieselbe Zeit in drei Formaten: die
 * Ankerarbeitsliste `7:44–8:09`, die Ankerliste `t=469.2s`, die
 * Shot-Liste `464.2–488.8 s`. Wer zwischen ihnen vergleicht, rechnet
 * ständig um — und beim Teilen, bei Schnitt-Hinweisen und bei Ankern ist
 * die **Sekundenzahl** der maßgebliche Wert, während man im Video nach
 * Minuten sucht.
 *
 * Deshalb überall beides, und aus derselben Quelle, damit die Formate
 * nicht wieder auseinanderlaufen.
 */

/** `469.23` → `"7:49"`. Sekunden werden gerundet, nicht abgeschnitten. */
export const mmss = (t) => {
  const s = Math.max(0, Math.round(Number(t) || 0));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};

/**
 * `469.23` → `"469.2 s · 7:49"`.
 *
 * Sekunden zuerst: das ist der Wert, den man kopiert und in ein Feld
 * einträgt. Die Minuten stehen dahinter als Orientierung im Video.
 */
export const bothTimes = (t, digits = 1) => {
  const n = Number(t) || 0;
  return `${n.toFixed(digits)} s · ${mmss(n)}`;
};

/**
 * `464.17, 488.8` → `"464.2–488.8 s · 7:44–8:09"`.
 *
 * Eine Spanne, kompakt: nicht `464.2 s · 7:44 – 488.8 s · 8:09`, das
 * liest sich in einer 10-px-Monospace-Zeile nicht mehr.
 */
export const bothSpans = (a, b, digits = 1) => {
  const x = Number(a) || 0;
  const y = Number(b) || 0;
  return `${x.toFixed(digits)}–${y.toFixed(digits)} s · ${mmss(x)}–${mmss(y)}`;
};
